export default "__VITE_ASSET__CSdRDsWk__"